function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Descriptions, Select, message, InputNumber, Tabs, Divider } from 'antd';
import Common from "../includes/Common";
import { Container, Row, Col } from "react-bootstrap";
import { Activity, EyeFill, Clipboard2Pulse } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var TabPane = Tabs.TabPane;

var NewConsultation = function NewConsultation(_ref) {
  var _ref$patient = _ref.patient,
      patient = _ref$patient === void 0 ? null : _ref$patient,
      _ref$queueId = _ref.queueId,
      queueId = _ref$queueId === void 0 ? null : _ref$queueId,
      _ref$queueData = _ref.queueData,
      queueData = _ref$queueData === void 0 ? null : _ref$queueData,
      handler = _ref.handler;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      formLoading = _useState2[0],
      setFormLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      successMessage = _useState6[0],
      setSuccessMessage = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      isDataLoading = _useState8[0],
      setIsDataLoading = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      bilanOptions = _useState10[0],
      setBilanOptions = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      serviceTree = _useState12[0],
      setServiceTree = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      medicalExamId = _useState14[0],
      setMedicalExamId = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      isPatientUpdated = _useState16[0],
      setIsPatientUpdated = _useState16[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _Form$useForm3 = Form.useForm(),
      _Form$useForm4 = _slicedToArray(_Form$useForm3, 1),
      mcForm = _Form$useForm4[0];

  var onCheckFinish = function onCheckFinish(values) {
    setErrorMessage('');
    setSuccessMessage('');
    setFormLoading(true);
    var formData = new FormData();
    formData.append("exam_general", values.exam_general);
    formData.append("exam_neuro", values.exam_neuro);
    formData.append("exam_pleuro", values.exam_pleuro);
    formData.append("exam_cardio", values.exam_cardio);
    formData.append("exam_rhuma", values.exam_rhuma);
    formData.append("exam_cutaneo", values.exam_cutaneo);
    formData.append("exam_other", values.exam_other);
    formData.append("resum_syndrome", values.resum_syndrome);
    formData.append("hypo_diagnostic", values.hypo_diagnostic);
    formData.append("final_diagnostic", values.final_diagnostic);
    formData.append("treatments", values.treatments);
    formData.append("recommandations", values.recommandations);
    formData.append("uid", Common.currentUser.id);
    formData.append("business_account_medical_item_id", medicalExamId);
    formData.append("customer_id", patient.id);
    formData.append("queue_id", queueId);
    axios.post(Common.baseApiUrl + 'setmedicalcheckdetails', formData).then(function (response) {
      setFormLoading(false);

      if (response.data.status == 200) {
        setIsPatientUpdated(false);
        setSuccessMessage(response.data.message);
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
      setFormLoading(false);
    });
  };

  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setSuccessMessage('');
    setFormLoading(true);
    var formData = new FormData();
    formData.append("reason", values.reason);
    formData.append("traitement_anterieur", values.traitement_anterieur);
    formData.append('weight', values.weight);
    formData.append('ta', values.ta);
    formData.append("pulse", values.pulse);
    formData.append("temperature", values.temperature);
    formData.append("spO2", values.spO2);
    formData.append("glycemy", values.glycemy);
    formData.append("tt", values.tt);
    formData.append("ant_medicals", values.ant_medicals);
    formData.append("ant_chirugicals", values.ant_chirugicals);
    formData.append("ant_gyn", values.ant_gyn);
    formData.append("ant_family", values.ant_family);
    formData.append("queue_id", queueId);
    formData.append("uid", Common.currentUser.id);
    formData.append("customer_id", patient.id);
    formData.append("business_account_medical_item_id", medicalExamId);
    axios.post(Common.baseApiUrl + 'setmedicalcheckintro', formData).then(function (response) {
      setFormLoading(false);

      if (response.data.status == 200) {
        setIsPatientUpdated(true);
        setSuccessMessage(response.data.message);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
      setFormLoading(false);
    });
  };

  useEffect(function () {
    queueData.forEach(function (qd) {
      qd.queue_item_elements.forEach(function (item) {
        setMedicalExamId(item.business_account_medical_item.id);
      });
    });
    axios.get(Common.baseApiUrl + 'getservicetree/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        response.data.services.forEach(function (dept) {
          if (dept.dcode != "CON" && dept.dcode != "REC" && dept.dcode != "ADM") {
            dept.business_account_medical_items.forEach(function (mi) {
              setBilanOptions(function (prev) {
                return [].concat(_toConsumableArray(prev), [{
                  label: mi.label,
                  value: mi.id
                }]);
              });
            });
          }
        });
        form.setFieldsValue({
          bilan: bilanOptions
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue ' + error.toString(),
        delay: 4
      });
    })["finally"](function () {});
    form.setFieldsValue({
      reason: '',
      traitement_anterieur: '',
      weight: '',
      ta: '',
      pulse: '',
      temperature: '',
      spO2: '',
      glycemy: '',
      tt: '',
      ant_medicals: '',
      ant_chirugicals: '',
      ant_gyn: '',
      ant_family: ''
    });
    mcForm.setFieldsValue(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      diagnostic: '',
      indication: '',
      conduite: '',
      conclusion: '',
      reason: '',
      traitement_anterieur: '',
      exam_general: '',
      exam_neuro: '',
      exam_pleuro: ''
    }, "exam_pleuro", ''), "exam_rhuma", ''), "exam_cutaneo", ''), "exam_other", ''), "resum_syndrome", ''), "hypo_diagnostic", ''), "final_diagnostic", ''), "treatments", ''), "recommandations", ''));
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: patient != null ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 9,
            md: 9,
            children: /*#__PURE__*/_jsxs(Tabs, {
              animated: true,
              defaultActiveKey: 1,
              children: [/*#__PURE__*/_jsxs(TabPane, {
                tab: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(Activity, {
                    style: {
                      color: "#91C287"
                    },
                    size: 30
                  }), "PLAINTE ET CONSTANTES"]
                }),
                children: [/*#__PURE__*/_jsx("br", {}), errorMessage && errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
                  type: "error",
                  banner: true,
                  message: errorMessage
                }), successMessage && successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
                  type: "success",
                  banner: true,
                  message: successMessage
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
                  form: form,
                  layout: "vertical",
                  onFinish: onFinish,
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "reason",
                    label: "Motif / Motivo de la visita",
                    rules: [{
                      required: true,
                      message: "Ce champ est obligatoire"
                    }],
                    children: /*#__PURE__*/_jsx(Input, {})
                  }), /*#__PURE__*/_jsx(Row, {
                    children: /*#__PURE__*/_jsx(Col, {
                      lg: 12,
                      md: 12,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "traitement_anterieur",
                        label: "Histoire de la maladie / Historia de la enfermedad",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "CONSTANTES / CONSTANTES"
                      })
                    }), /*#__PURE__*/_jsxs(Row, {
                      children: [/*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 4,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "ta",
                          label: "TA / Presi\xF3n arterial",
                          children: /*#__PURE__*/_jsx(Input, {
                            addonAfter: "mmHg"
                          })
                        })
                      }), /*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 4,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "pulse",
                          label: "Pouls / Legumbres",
                          children: /*#__PURE__*/_jsx(Input, {
                            addonAfter: "Pouls/Min"
                          })
                        })
                      }), /*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 4,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "temperature",
                          label: "Temperature / Temperatura",
                          children: /*#__PURE__*/_jsx(Input, {
                            addonAfter: "\xB0C"
                          })
                        })
                      })]
                    }), /*#__PURE__*/_jsxs(Row, {
                      children: [/*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 4,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "spO2",
                          label: "SpO2 / saturaci\xF3n de ox\xEDgeno en sangre",
                          children: /*#__PURE__*/_jsx(Input, {})
                        })
                      }), /*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 4,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "glycemy",
                          label: "Glycemie / Glucemia",
                          children: /*#__PURE__*/_jsx(Input, {
                            addonAfter: "g/L"
                          })
                        })
                      }), /*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 4,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "weight",
                          label: "Poids / Peso",
                          children: /*#__PURE__*/_jsx(InputNumber, {
                            addonAfter: "Kg"
                          })
                        })
                      })]
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "tt",
                      label: "TT / tratamiento",
                      children: /*#__PURE__*/_jsx(Input, {})
                    })]
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "ANTECEDANTS / HISTORIA"
                      })
                    }), /*#__PURE__*/_jsx("h6", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "PERSONNELS / PERSONAL"
                      })
                    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ant_medicals",
                      label: "Medicaux / M\xE9dico",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ant_chirugicals",
                      label: "Chirugicaux / Quir\xFArgico",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ant_gyn",
                      label: "Gyn\xE9co-obstetrique / Ginecolog\xEDa-obstetricia",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    }), /*#__PURE__*/_jsx("h6", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "FAMILIAUX / FAMILIAS"
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "ant_family",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    })]
                  }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Alert, {
                      message: errorMessage,
                      type: "error",
                      banner: true
                    })
                  }), successMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Alert, {
                      message: successMessage,
                      type: "success",
                      banner: true
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      loading: formLoading,
                      type: "primary",
                      htmlType: "submit",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "SAUVEGARDER"
                      })
                    })
                  })]
                })]
              }, 1), /*#__PURE__*/_jsx(TabPane, {
                tab: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(Clipboard2Pulse, {
                    style: {
                      color: "#91C287"
                    },
                    size: 30
                  }), " CONSULTATION / CONSULTA"]
                }),
                children: /*#__PURE__*/_jsxs(Form, {
                  form: mcForm,
                  layout: "vertical",
                  onFinish: onCheckFinish,
                  children: [/*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: "EXAMENS / EXAMENES"
                    }), /*#__PURE__*/_jsx(Container, {
                      children: /*#__PURE__*/_jsxs(Row, {
                        children: [/*#__PURE__*/_jsx(Col, {
                          lg: 6,
                          md: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen g\xE9n\xE9ral / Examen general",
                            name: "exam_general",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 6,
                          md: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen neurologique / Examen neurol\xF3gico",
                            name: "exam_neuro",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 6,
                          md: 6,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen cardiovasculaire / examen cardiovascular",
                            name: "exam_cardio",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 12,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen rhumatologique / Examen reumatol\xF3gico",
                            name: "exam_rhuma",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 12,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen pleuropulmonaire / Examen pleuropulmonar",
                            name: "exam_pleuro",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 12,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen cutan\xE9o-phan\xE9rien / Examen de la piel y el fan\xE9rico",
                            name: "exam_cutaneo",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        }), /*#__PURE__*/_jsx(Col, {
                          lg: 12,
                          children: /*#__PURE__*/_jsx(Form.Item, {
                            label: "Examen ailleurs / Revisar en otro lugar",
                            name: "exam_other",
                            children: /*#__PURE__*/_jsx(TextArea, {
                              autoSize: true
                            })
                          })
                        })]
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: "R\xE9sum\xE9 Syndromique / Resumen sindr\xF3mico"
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "resum_syndrome",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("legend", {
                      children: "Hypoth\xE8ses diagnostiques / Hip\xF3tesis diagn\xF3sticas"
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      name: "hypo_diagnostic",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("fieldset", {
                    children: [/*#__PURE__*/_jsx("length", {
                      children: "CONCLUSION / CONCLUSI\xD3N"
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      label: "Diagnostic retenu / Diagn\xF3stico retenido",
                      name: "final_diagnostic",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      label: "Traitements / Tratos",
                      name: "treatments",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    }), /*#__PURE__*/_jsx(Form.Item, {
                      label: "Recommandations / Recomendaciones",
                      name: "recommandations",
                      children: /*#__PURE__*/_jsx(TextArea, {
                        autoSize: true
                      })
                    })]
                  }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Alert, {
                      message: errorMessage,
                      type: "error",
                      banner: true
                    })
                  }), successMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Alert, {
                      message: successMessage,
                      type: "success",
                      banner: true
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      loading: formLoading,
                      type: "primary",
                      htmlType: "submit",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "SAUVEGARDER"
                      })
                    })
                  })]
                })
              }, 2)]
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                background: "#D87054",
                backgroundRadius: "7px"
              },
              children: /*#__PURE__*/_jsxs(Descriptions, {
                labelStyle: {
                  color: '#EEE'
                },
                contentStyle: {
                  color: '#EEE'
                },
                column: 1,
                bordered: true,
                children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Nom",
                  children: patient.lastname
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Pr\xE9nom",
                  children: patient.firstname
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Profession",
                  children: patient.job
                })]
              })
            })
          })]
        })
      })
    }) : /*#__PURE__*/_jsx("p", {
      children: "Une erreur est survenue"
    })
  });
};

export default NewConsultation;